export default {
    修改名称: '修改名称',
    yyy: '印丫云是印路（上海）科技有限公司发布运营的国内首 个全中文云端印前处理系统，引领着数字化浪潮中印前革命的新时代。采用全线上模式，告别传统束缚，使印前处理摆脱硬件和客户端的约束，为用户提供真正灵活和便利的一键印前文件处理。平台以用户为中心，提供文件预检、自动陷 印、像素级对比、个性化参数设置、一键RIP分色、多格式文件转换、智能柔印和AI画质增强等无边界功能体验。安全存储于云端，支持团队合作的文件审批功能，为沟通对接搭建桥梁。印丫云，不仅是印前处理系统，更是印前新时代的 开端，轻松高效助您迎接数字印前的未来。'
}
